import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";

import Header from '../../layout/Header'
import Subheader from '../../layout/Subheader'

import useStyles from './style'
import { calcLengthBtnMenu, getURL } from "../../services/auth";

function HomeRender () {
  const { menus } = JSON.parse(sessionStorage.getItem('@Capitalle-Menu'));
  const currentControler = sessionStorage.getItem('@Capitalle-Current-Menu');
  const classes = useStyles()
  const [largerItemLenght, setLargerItemLenght] = useState(0);
  const [controle, setControle] = useState(1)
  const [pageTitle, setPageTitle] = useState('Pagina Inicial')

  const handleChangeControle = (menu) => {
    if(menu.acao == "ProximoControle" || menu.acao == "ControleAnterior" ) {
      if(menu.irParaControle == 1) {
        setPageTitle('Pagina Inicial')
      } else if(menu.acao == "ControleAnterior") {
        const currentMenu = menus.find((x) => x.irParaControle == currentControler)

        if(currentMenu) {
          setPageTitle(currentMenu.titulo)
        } else {
          setPageTitle('Pagina Inicial')
        }
      } else {
        setPageTitle(menu.titulo)
      }

      sessionStorage.setItem('@Capitalle-Current-Menu', menu.irParaControle)
      setControle(menu.irParaControle)
    }
  }

  useEffect(() => {
    setLargerItemLenght(0)
  },[controle])

  useEffect(() => {
    if(!currentControler || !menus) {
      sessionStorage.setItem('@Capitalle-Current-Menu', 1)
      setControle(1)
      setPageTitle('Pagina Inicial')
    } else {
      setControle(currentControler)
      const currentMenu = menus.find((x) => x.irParaControle == currentControler)

      if(currentMenu && currentControler != 1) {
        setPageTitle(currentMenu.titulo)
      } else {
        setPageTitle('Pagina Inicial')
      }
    }
  }, [])

  return (
    <div className={classes.root}>
      <Header />
      <Subheader title={pageTitle} />
      <div className={classes.content}>
        <div className={classes.contentHome}>
          {menus && menus.map((menu) => (
            <>
              {menu.controle == controle && (
                <Link
                  to={menu.acao == "CarregaUrl" ? getURL(menu.moduloId) : '#'}
                  onClick={() => handleChangeControle(menu)}
                  className={classes.cardLink}
                  style={{ width: calcLengthBtnMenu(menu.titulo, setLargerItemLenght, largerItemLenght), backgroundColor: menu.corFundo }}>
                  <span className={classes.cardLinkText} style={{ color: menu.corFonte }}>{menu.titulo}</span>
                </Link>
              )}
            </>
          ))}
        </div>
      </div>
    </div>
  )
}

export default HomeRender
